export const ENGLISH_LOCALE = require('./en');
export const SPANISH_LOCALE = require('./es');
